import { useMemo, useState } from 'react'
import { CurrentHcsContextValue } from './types'
import { CurrentHcsContext } from './CurrentHcsContext'
import { CurrentUserProviderProps } from '../../../User/_props'

export const CurrentHcsProvider = ({ children }: CurrentUserProviderProps) => {
    const [currentHcs, setCurrentHcs] = useState<CurrentHcsContextValue['currentHcs']>(null)

    const value = useMemo(
        () => ({
            currentHcs,
            setCurrentHcs,
        }),
        [currentHcs, setCurrentHcs],
    )

    return <CurrentHcsContext.Provider value={value}>{children}</CurrentHcsContext.Provider>
}
